module.exports = __webpack_public_path__ + "static/media/113-low volume.18151baa.svg";